<div class="dashboard__content mt-4 pb-5" [class.d-none]="!isLoaded">
    <div class="row mb-4 wh-breadcrumb g-0 text-uppercase">
    
        <div class="col-auto">
            <span class="small text-muted">Winning Hands Admin</span>
        </div>
        <div class="col-auto">
            <span class="small text-muted">&nbsp;<mat-icon>chevron_right</mat-icon>&nbsp;</span>
        </div>
        <div class="col-auto">
            <a [routerLink]="[ '/', 'admin', 'events' ]" class="small text-primary text-decoration-none"> Events</a>
        </div>
        
    </div>
    
    <div class="row mb-4">
        <div class="col">
            <h1 class="mb-0">EVENTS</h1>
        </div>
        <div class="col-auto">
            <button (click)="goToAllEvents();" mat-flat-button class="w-100" color="primary"
                    cdkFocusInitial>VIEW ALL EVENTS</button>
        </div>
    </div>


    @if (activeEventsList && activeEventsList.length > 0){
    <div class="row g-4 mt-4 mb-3">
        <div class="col">
            <h3>ACTIVE EVENTS</h3>
        </div>
    </div>

    <div class="row g-4  mb-4">
        @for (event of activeEventsList; track event.eventID){
        <div class="col-12 col-lg-4">
            <div class="card p-4 text-center rounded-0 text-uppercase">
                <h4 class="">{{event.eventName}}</h4>
                <p>{{event.startDate | date:'dd MMM YYYY'}} - {{event.endDate | date:'dd MMM YYYY'}}</p>
                <p>{{event.city}} - {{event.country}}</p>
                <button (click)="goToEventDashboard(event.eventID)" mat-flat-button class="w-100" color="primary"
                    cdkFocusInitial>VIEW DASHBOARD</button>
            </div>
        </div>
        }
    </div>
    }

    @if (upcomingEventsList && upcomingEventsList.length > 0){
    <div class="row g-4 mt-4 mb-3">
        <div class="col">
            <h3>UPCOMING EVENTS</h3>
        </div>
    </div>

    <div class="row g-4 mb-4">
        @for (event of upcomingEventsList; track event.eventID){
        <div class="col-12 col-lg-4">
            <div class="card p-4 text-center rounded-0 text-uppercase">
                <h4>{{event.eventName}}</h4>
                <p>{{event.startDate | date:'dd MMM YYYY'}} - {{event.endDate | date:'dd MMM YYYY'}}</p>
                <p>{{event.city}} - {{event.country}}</p>
                <button (click)="goToEventDashboard(event.eventID)" mat-flat-button class="w-100" color="primary"
                    cdkFocusInitial>VIEW DASHBOARD</button>
            </div>
        </div>
        }
    </div>
    }

</div>
